import React, { useEffect, useState } from 'react';
import userDetailsStyles from "../../../styles/userDetails/userDetails.module.css";
import appointmentStyles from "../../../styles/userDetails/appointmentScheduler.module.css";
import BranchZipcodeClient from "../../../utility/features/api_clients/adminDashboard/branchZipcodeClient.js";


const ViewBranchModal = ({branchDetails}) => {  
       const {id} = branchDetails;
       const [loading, setLoading] = useState(false);
       const [zipcodes, setZipCodes] = useState([]);
    
        useEffect(() => {
            setLoading(true);
            const getBranchZipcodes = async () => {
                try {
                    const resp = await BranchZipcodeClient(branchDetails.branchID,true);
                    if (resp.status === 200) {
                        resp.data ? setZipCodes(resp.data.map(item => item.postalCodeID)) : setZipCodes([]);
                    }
                } catch (err) {
                    console.log("Error fetching branch zipcode details:", err);
                    setZipCodes([])
                }
                setLoading(false);
            }
            if(branchDetails.branchID) getBranchZipcodes();
        }, [branchDetails?.branchID]);
    
    return (

        <div className={`modal fade ${userDetailsStyles["userDetailsModal"]}`} id="viewBranchModal" tabIndex="-1" aria-labelledby="viewBranchModalLabel" aria-hidden="true">
            <div className={`modal-dialog ${userDetailsStyles["modal-dialog"]}`}>
                <div className={`modal-content ${userDetailsStyles["modal-content"]}`}>
                    <div className={`modal-header ${userDetailsStyles["modal-header"]}`}>
                        <h5 id="viewBranchModalLabel" className={`modal-title ${userDetailsStyles["modal-title"]}`}>View Branch Details</h5>
                        <button type="button" className={`btn-close ${userDetailsStyles["btn-close"]}`} data-bs-dismiss="modal" aria-label="Close"
                        />
                    </div>
                    <div className={`modal-body ${userDetailsStyles["modal-body"]}`}>
                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Branch ID:</span>
                            <span className={appointmentStyles["value"]}>{branchDetails?.branchID || "-"}</span>
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Branch Name:</span>
                            <span className={appointmentStyles["value"]}>{branchDetails?.branchName || "-"}</span>
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Zip Codes:</span>
                            {loading 
                            ?<span className={appointmentStyles["value"]}>Fetching zipcodes...</span>
                            :<span className={appointmentStyles["value"]}>
                                {zipcodes.length > 0 
                                ? zipcodes.join(", ")
                                : `No zipcodes available for ${branchDetails?.branchName} - ${branchDetails?.id}`}
                            </span> }
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Appointment Slots:</span>
                            <span className={appointmentStyles["value"]}>
                                {branchDetails?.availableSlots}                              
                            </span>
                        </div>
                         <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Status:</span>
                            <span className={`${appointmentStyles["value"]} ${branchDetails?.isBranchEnabled ? "text-success" : "text-danger"}`}>
                                {branchDetails?.isBranchEnabled ? "Active" : "In Active"}                              
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewBranchModal
